import * as React from 'react';
import { Form, FormGroup, TextInput } from '@patternfly/react-core';
import { CheckInputField } from '../../config/bootstrap';

interface CheckInputFormProps {
  schema: CheckInputField[];
  values: Record<string, string>;
  errors: Record<string, string | null>;
  onChange: (name: string, value: string) => void;
  onBlur: (name: string, value: string) => void;
}

export const validateField = (field: CheckInputField, value: string): string | null => {
  const trimmed = value.trim();
  if (field.required && !trimmed) {
    return `Please enter ${field.label.toLowerCase()}.`;
  }
  if (trimmed && field.pattern) {
    if (!new RegExp(field.pattern).test(trimmed)) {
      return `Please enter a valid ${field.label.toLowerCase()}.`;
    }
  }
  if (field.name === 'siteUrl' && trimmed) {
    try {
      const url = new URL(trimmed);
      if (!url.protocol.startsWith('https')) {
        return 'The site URL must start with https.';
      }
    } catch {
      return 'Please enter a valid URL, for example https://contoso.sharepoint.com/sites/testsite.';
    }
  }
  return null;
};

export const CheckInputForm: React.FunctionComponent<CheckInputFormProps> = ({
  schema,
  values,
  errors,
  onChange,
  onBlur,
}) => (
  <Form style={{ marginTop: '1rem' }}>
    {schema.map((field) => (
      <FormGroup key={field.name} label={field.label} isRequired={field.required} fieldId={field.name}>
        <TextInput
          isRequired={field.required}
          type={(field.type as any) || 'text'}
          id={field.name}
          name={field.name}
          value={values[field.name] || ''}
          placeholder={field.placeholder}
          onChange={(_, value) => onChange(field.name, value)}
          onBlur={(event) => onBlur(field.name, event.currentTarget.value)}
        />
        {errors[field.name] && (
          <p style={{ color: 'var(--pf-v5-global--danger-color--100)', marginTop: '0.25rem' }}>
            {errors[field.name]}
          </p>
        )}
      </FormGroup>
    ))}
  </Form>
);
